import React from 'react';
import { Spinner, Table } from 'react-bootstrap';
import RenderPagination from '../../../../../components/molecules/pagination';
import useRenderTableRefund from './hooks';
import { renderDate, classNameHeader } from '../utils';
import RenderStatus from './RenderStatus';

interface Props {
    status: 'PAID' | 'UNPAID' | null;
    page: {current: number, setCurrent: React.Dispatch<number>}
    // eslint-disable-next-line no-unused-vars
    renderVM: (type: number | null, deviceId: string | null, clientName: string | null) => React.ReactElement;
}

function RenderTableRefund(props: Props) {
  const { status, page, renderVM } = props;
  const { refund, formik, modal } = useRenderTableRefund(status, page.current);

  return (
    <div
      className="border border-1 border-color-stroke w-100 mb-4 py-2"
      style={{ borderRadius: '20px' }}
    >
      <Table borderless responsive>
        <thead>
          <tr>
            <th className={`${classNameHeader} ps-4 ps-xl-5`}>VENDING MACHINE (MACHINE ID)</th>
            <th className={classNameHeader}>PERSONAL INFO</th>
            <th className={classNameHeader}>LOCATION</th>
            <th className={classNameHeader}>REQUEST DATE</th>
            <th className={classNameHeader}>REQUEST AMOUNT</th>
            <th className={`${classNameHeader} pe-4 pe-xl-5`} style={{ width: 120 }}>REFUND AMOUNT</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            if (refund.load) {
              return (
                <tr>
                  <td colSpan={6} className="text-center">
                    <div className="my-2"><Spinner animation="border" /></div>
                  </td>
                </tr>
              );
            } if (refund.data && refund.data?.length) {
              return refund.data.filter((x, i) => refund.data && x.id !== refund.data[i + 1]?.id).map((data, i) => (
                <tr
                  key={`refund${data.id}`}
                  className={i % 2 !== 0 ? 'bg-solid align-middle' : 'align-middle'}
                  style={{ height: '50px' }}
                >
                  <td className="ps-4 ps-xl-5">
                    {renderVM(data.vendingMachine.type, data.vendingMachine.deviceId, data.clientName)}
                  </td>
                  <td className="fz-14" style={{ minWidth: 200 }}>
                    <div>{data.firstname && data.lastname ? `${data.firstname} ${data.lastname}` : '-'}</div>
                    <div>{data.phoneNumber ?? '-'}</div>
                    <div>{data.email ?? '-'}</div>
                  </td>
                  <td className="fz-14" style={{ minWidth: 200 }}>{data.vendingMachine.location ?? '-'}</td>
                  <td className="fz-14" style={{ minWidth: 150 }}>{renderDate(data.requestDate)}</td>
                  <td className="fz-14" style={{ minWidth: 150 }}>{data.requestAmount ?? 0}</td>
                  <td className="fz-14 pe-4 pe-xl-5">
                    <div className="d-flex justify-content-end align-items-center">
                      <RenderStatus
                        refundDate={data.refundDate}
                        refundAmount={data.refundAmount}
                        id={data.id}
                        formik={formik}
                        modal={modal}
                      />
                    </div>
                  </td>
                </tr>
              ));
            }
            return (
              <tr>
                <td colSpan={6} className="text-center fz-14">
                  <div className="my-2">Data Not Found</div>
                </td>
              </tr>
            );
          })()}
        </tbody>
      </Table>
      <div className="d-flex align-items-center justify-content-end mt-4 pe-4 pe-xl-5">
        <RenderPagination
          currentPage={page.current}
          setCurrentPage={page.setCurrent}
          totalPage={refund.totalPages}
        />
      </div>
    </div>
  );
}

export default React.memo(RenderTableRefund);
